module.exports = __webpack_public_path__ + "assets/img/title.ae6ab84e.png";